import Ultrarubigram from './Ultrarubigram';

export default Ultrarubigram;
